import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const TIMEFRAMES = [
  ['today', 'Today'], ['yesterday', 'Yesterday'], ['this-week', 'This Week'], ['last-week', 'Last Week'],
  ['this-month', 'This Month'], ['last-month', 'Last Month'], ['this-year', 'This Year'], ['all-time', 'All Time'],
  ['custom', 'Custom dates'],
];

export const PREV_LABEL = {
  today: 'vs yesterday', yesterday: 'vs day before', 'this-week': 'vs last week', 'last-week': 'vs week before',
  'this-month': 'vs last month', 'last-month': 'vs month before', 'this-year': 'vs last year',
  custom: 'vs previous period',
};

export const money = (v) => `$${(v ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const pct = (v) => `${((v ?? 0) * 100).toFixed(1)}%`;
export const respTime = (ms) => {
  if (ms == null) return '—';
  const s = Math.round(ms / 1000);
  return s < 60 ? `${s}s` : `${Math.floor(s / 60)}m ${s % 60}s`;
};

const today = () => new Date().toISOString().slice(0, 10);

export const DateRangeInputs = ({ range, onChange }) => (
  <div className="flex items-center gap-2" data-testid="custom-date-range">
    <input type="date" value={range.start} max={range.end || today()} onChange={e => onChange({ ...range, start: e.target.value })}
      className="h-10 rounded-md bg-zinc-900/50 border border-zinc-800 text-white px-3 text-sm [color-scheme:dark]" data-testid="custom-start-date" />
    <span className="text-zinc-500 text-sm">→</span>
    <input type="date" value={range.end} min={range.start} onChange={e => onChange({ ...range, end: e.target.value })}
      className="h-10 rounded-md bg-zinc-900/50 border border-zinc-800 text-white px-3 text-sm [color-scheme:dark]" data-testid="custom-end-date" />
  </div>
);

export const TimeframeSelect = ({ value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-48 bg-zinc-900/50 border-zinc-800 text-white" data-testid="timeframe-select">
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-zinc-900 border-zinc-800 text-white">
      {TIMEFRAMES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);
